import { TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { html } from 'lit/static-html.js';

import componentStyles from './sic-heading.css.lit';

export type AllowedHeadingSizes = '1' | '2' | '3' | '4' | '5' | '6' | '7';
export type AllowedHeadingStyles = 'bold' | 'normal';

/**
 * The Heading component.
 * @element sic-heading
 * @slot defaultSlot
 *
 * @property {string} level-size
 * @property {string} level-style
 *
 * Lightdom styles in sic-heading.lightdom.css included in /shared.css
 */
@customElement('sic-heading')
export class SicHeading extends OutlineElement {
  static styles = [componentStyles];

  /**
   * The heading level size to apply. Optional override to default styles for a given level
   */
  @property({ type: String, reflect: true, attribute: 'level-size' })
  levelSize: AllowedHeadingSizes;

  /**
   * The heading level style to apply. Optional override to default styles for a given level
   */
  @property({ type: String, reflect: true, attribute: 'level-style' })
  levelStyle: AllowedHeadingStyles = 'bold';

  updated() {
    this.setStyleTag();
  }
  setStyleTag() {
    if (this.levelSize) {
      this.style.setProperty(
        '--heading-font-size',
        `var(--headline-0${this.levelSize}-font-size)`
      );
      this.style.setProperty(
        '--heading-line-height',
        `var(--headline-0${this.levelSize}-line-height)`
      );
    }
  }

  render(): TemplateResult {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sic-heading': SicHeading;
  }
}
